import { debounce, uniqueId } from 'lodash';
import React, { useEffect, useRef, useState } from 'react'
import DatePicker from "react-datepicker";
import { createOrUpdateBillingApi, getAllOrByIdOrDownloadBillingApi, getNextRABillNoApi } from '../../utils/ApiEndpointFunctions';
import { useFormik } from 'formik';
import {  billingInitalValue, billingValidationSchema,  } from '../../utils/Validation';
import Spinwheel from '../../components/common/Spinwheel';
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ConfirmationModal from '../../components/modal/ConfirmationModal';
import { formatPrice, getRoundOff } from '../../utils/HelperFuncitons';
import { useUserContext } from '../../context/userContext';
import moment from 'moment';
import StatusModal from '../../components/modal/StatusModal';
import * as XLSX from 'xlsx-js-style';
import ViewBilling from './ViewBilling';
import BillingSubSection from '../../components/common/BillingSubSection';


function AddOrUpdateBilling() {
  const { userDetails,langPreference} = useUserContext();
  const [searchParams, setSearchParams]  = useSearchParams()
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { id } = params;
  const [addLoader, setAddLoader] = useState(false)
  const [confirmationMsg, setConfirmationMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [updateItem,setUpdateItem] = useState({index:null,loading:false})
  const [raNumberLoading, setRaNumberLoading] = useState(false)
  const [addListItem,setAddListItem] = useState([{seqNo:null,billingSeqNoId:null,seqDetails:null,items:[]}])
  const [unSavedSeq,setUnSavedSeq] = useState([])
  const submitConfirmModal = "submitConfirmModal1"
  const statusModalId = "statusModal1"
  const handleSelectDate = (e, eleType) => {
    billingFormik.setFieldValue(eleType, new Date(e).toISOString())
  };


  const handleBillingSubmit = async (values) => {
    // console.log("handleBillingSubmit",values);
    
  }

  const billingFormik = useFormik({
    initialValues: billingInitalValue,
    onSubmit: handleBillingSubmit,
    validationSchema: billingValidationSchema(langPreference)
  })

  const getBillingDetails = async()=>{
    try {
      setLoading(true)
      const res = await getAllOrByIdOrDownloadBillingApi("","","","",id)
      if (res.status === 200) {
        const {billing} = res?.data?.data
       if(billing?.[0]){
        let listItems  =[]
        billing[0]?.seqNo?.forEach(ele=>{
          listItems.push({
            seqNo:ele?.seqNo,billingSeqNoId:ele?._id,
            seqDetails:{
              category:ele?.category || "",
              subCategory:ele?.subCategory || "",
              boqId:ele?.boqId || "",
              boqItemId:ele?.boqItemId || "",
              vendorId:ele?.vendorId || "",
              uniqueItemId:ele?.uniqueItemId || "",
              date:ele?.date||""
            },
            items:ele?.billingItems?.map(ele=>{return {...ele,selected:true,saved:true}})
          })
        })
        setAddListItem(listItems)
        billingFormik.setFieldValue("raBillNo",billing[0]?.raBillNo)
        billingFormik.setFieldValue("billType",billing[0]?.billType)
        billingFormik.setFieldValue("billDate",billing[0]?.billDate)
        billingFormik.setFieldValue("_id",billing[0]?._id)
       }
      }
   } catch (error) {
     toast.error(error?.response?.data?.message || "Something went wrong")
     console.log("error", error);
    }
    setLoading(false)
  }


  const handleConfirmation = (isConvert) => {
    billingFormik.handleSubmit();
  }

  const handleApprovalModalClose = () => {
     navigate("/boq")
  }

useEffect(()=>{
  let tab = searchParams?.get("tab")
  if(tab && !id){
    billingFormik.setFieldValue("billType",tab)
  }
  if(id){
    getBillingDetails()
  }
},[searchParams?.get("tab"),id])

useEffect(() => {
  const getNextRABillNo = async () => {
    if (id || !billingFormik?.values?.billType || billingFormik?.values?.raBillNo) return
    try {
      setRaNumberLoading(true)
      const res = await getNextRABillNoApi()
      if (res.status === 200) {
        billingFormik.setFieldValue("raBillNo", res?.data?.data?.raBillNo || "1")
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || langPreference?.unable_to_suggest_ra_bill_no || "Unable to suggest RA Bill No")
    } finally {
      setRaNumberLoading(false)
    }
  }

  getNextRABillNo()
}, [id, billingFormik?.values?.billType])

const handlePreview =(previewId)=>{
  const tab = searchParams?.get("tab")
if(billingFormik?.values?._id){
  const isPreview = searchParams?.get("preview")
  setSearchParams({tab,preview:isPreview ? "" :billingFormik?.values?._id})
}else{
  navigate(`/billing/update/${previewId}?tab=${tab}`)
}
}

const handleAddRow = (index,newlist,oldList,necessayDetails,seqDetails)=>{
  let existIds = addListItem?.map(ele=>ele?.items)?.flat()?.map(ele => ele?.qtyItemId)?.filter(ele=>ele)
    const data = newlist?.map(ele => { return { ...ele, qtyItemId: ele?._id, ...necessayDetails, selected: false, saved: false } })?.filter(ele => !existIds?.includes(ele?.qtyItemId))
    let updatedData = [...oldList,...data]
    let updatedList = addListItem?.map((ele,ind)=>{
      if(index==ind){
        return{
          ...ele,
          seqDetails,
          items:updatedData
        }
      }else{
        return ele
      }
    })
    
    setAddListItem(updatedList)
    return data
}

 const handleChildSaveData =(index,list,billingSeqNoId)=>{
  let updatedList = addListItem?.map((ele,ind)=>{
    if(index==ind){
      return{
        ...ele,
        items:list,
        billingSeqNoId
      }
    }else{
      return ele
    }
  })
  
  setAddListItem(updatedList)
 }

 const resetParentData =(index)=>{
  let updatedList = addListItem?.map((ele,ind)=>{
    if(index==ind){
      return{
        ...ele,
        items:[],
        seqNo:null,billingSeqNoId:null,seqDetails:null,
      }
    }else{
      return ele
    }
  })
  
  setAddListItem(updatedList)
 }

 const removeSeqFromList =(index)=>{
  let updatedList = addListItem?.filter((ele,ind)=>index!=ind)
  setAddListItem(updatedList)
 }

  const trackUnsavedChanges = (index,status)=>{
  if(status){
    if(!unSavedSeq.includes(index)) setUnSavedSeq([...unSavedSeq,index])
  }else{
    setUnSavedSeq(unSavedSeq?.filter(ele=>ele!=index))
  }
 }

 const billingTypeLabel = billingFormik?.values?.billType === "client" ? (langPreference?.client || "Client") : (billingFormik?.values?.billType === "subcontractor" ? (langPreference?.subContractor || "Sub-contractor") : "-")

  return (
   <>{ searchParams?.get("preview") ? <ViewBilling isPreview={true} previewBack={handlePreview}/> :
    <>
      <div className="dash-nav1">
        <div className="d-block d-lg-flex align-items-center justify-content-between">
      <div className="back"><span onClick={() => navigate(`/billing?tab=${searchParams.get("tab") || "client"}&type=billing`)} className="back cursor-pointer" ><i className="bi bi-chevron-left"></i> {langPreference?.back || "Back"}</span></div>
          <h3 className="font-blue mb-0">{id ? langPreference?.edit_billing || "Edit Billing" : langPreference?.create_billing || "Add Billing"} </h3>
          <div>           
            <button type="button" disabled={loading || addLoader} onClick={()=>setAddListItem([...addListItem,{seqNo:null,billingSeqNoId:null,items:[]}])} className="mb-2 mb-sm-2 sbm-purchase">
              {loading ? <Spinwheel/> : langPreference?.add ||  "Add"}
            </button>
            {billingFormik?.values?._id && <button type="button" disabled={loading || addLoader} onClick={()=>!unSavedSeq?.length ? handlePreview() : toast?.error(langPreference?.save_to_continue || "Save to continue")} className="mb-2 mb-sm-2 sbm-purchase">
              {langPreference?.preview || "Preview"}
            </button>}
          </div>
        </div>
      </div>
      <div className="dash-table billing-create-page">
        <div className="container-fluid billing-create-page__container">
          <div className="row gap-3 gap-xl-0">
            <div className="col-12">
              <div className="">
                <div className='table-responsive border-0 m-0 position-relative items-detail-box billing-create-page__form'>
                <div className="form-details py-2 mb-2">
                    <div className='d-flex flex-column flex-xl-row align-items-xl-start justify-content-between gap-3'>
                      <div className='d-flex flex-wrap align-items-center gap-2 pt-xl-4'>
                        <span><strong>{langPreference?.company_name || "Company"}:</strong> {userDetails?.siteId?.companyId?.name || "-"}</span>
                        <span className='text-muted'>|</span>
                        <span><strong>{langPreference?.site_name || "Site"}:</strong> {userDetails?.siteId?.name || "-"}</span>
                        <span className='text-muted'>|</span>
                        <span><strong>{langPreference?.billing_type || "Type"}:</strong> {billingTypeLabel}</span>
                      </div>
                      <div className='d-flex flex-wrap align-items-start gap-3'>
                      <div className="d-flex flex-column" style={{width:"190px"}}>
                        <label htmlFor="billDate">{langPreference?.bill_date || "Bill Date"}</label>
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          placeholderText={langPreference?.bill_date || "Bill Date"}
                          className='form-select cursor-pointer'
                          name='billDate'
                          selected={billingFormik.values?.billDate}
                          onChange={(e) => { handleSelectDate(e, "billDate") }}
                          portalId="root"
                          popperClassName="billing-date-picker-popper"
                        />
                        <span id="billDate"></span>
                      </div>
                      <div className="d-flex flex-column" style={{width:"220px"}}>
                      <label htmlFor="raBillNo">{langPreference?.ra_bill_no || "RA Bill No"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name={`raBillNo`}
                          value={billingFormik?.values?.raBillNo}
                          onChange={billingFormik?.handleChange}
                          onBlur={billingFormik?.handleBlur}
                          disabled={raNumberLoading || updateItem?.loading || billingFormik?.values?._id}
                        />
                        {!id && <small className="text-muted">{langPreference?.ra_bill_no_suggestion || "Suggested automatically per site; you can change it."}</small>}
                        {billingFormik?.touched?.raBillNo && billingFormik?.errors?.raBillNo ? (<div className='req-error'>{billingFormik?.errors?.raBillNo}</div>) : null}
                      </div>
                      </div>
                    </div>
                  </div>
                  <h5>{billingFormik?.values?.billType === "subcontractor" ? (langPreference?.bill_details || "Bill Details") : (langPreference?.boq_details || "BOQ Details")}</h5>
                  {id && (
                    <div className="alert alert-info py-2 px-3 mb-3" role="alert">
                      {langPreference?.edit_billing_dpr_info || "To edit these details, please update the related DPR. Any changes made in DPR will apply to both Client and Sub-contractor billing."}
                    </div>
                  )}
                  {addListItem?.map((ele,index)=><div key={index+'index'}>
                    {console.log("index hai bhai",index)}
                    <BillingSubSection key={index} index={index}  details={ele} resetParentData={resetParentData} removeSeqFromList={removeSeqFromList} handleAddRow={handleAddRow} formik={billingFormik} handleChildSaveData={handleChildSaveData} trackUnsavedChanges={trackUnsavedChanges}/>
                  </div>
                  )}
                </div>
                  <>
                  </>

              </div>
            </div>

          </div>
        </div>
      </div>
      {/* for po approval */}
      <button className='d-none' id="submitModalBtn1" data-bs-toggle="modal" data-bs-target={`#${submitConfirmModal}`} />
      <ConfirmationModal modalId={submitConfirmModal} handleConfirm={() => handleConfirmation(false)} message={langPreference?.submit_confirmation || <>Are you sure you want to <br /> Submit ?</>} />
      <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
      <StatusModal
        modalId={statusModalId}
        message={confirmationMsg}
        handleClose={handleApprovalModalClose}
      />
    </>
    }</>
  )
}

export default AddOrUpdateBilling
